var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "flex-row d-flex font-size"
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "color": "black"
    },
    on: {
      "click": function click($event) {
        return _vm.decrease();
      }
    }
  }, [_vm._v("mdi-minus")]), _c('div', {
    staticClass: "size"
  }, [_vm._v(_vm._s(_vm.size))]), _c('v-icon', {
    attrs: {
      "small": "",
      "color": "black"
    },
    on: {
      "click": function click($event) {
        return _vm.increase();
      }
    }
  }, [_vm._v("mdi-plus")])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }